export interface RouteState {
  routeId: string;
}

export interface RouteAction {
  type: string;
  routeId: string;
}

export const initialState: RouteState = {
  routeId: "",
};

export const routeActions = {
  SET_ROUTE: "SET_ROUTE",
};

export const reducer = (state: RouteState, action: RouteAction): RouteState => {
  switch (action.type) {
    case routeActions.SET_ROUTE:
      return { routeId: action.routeId };
    default:
      return state;
  }
};
